
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search } from "lucide-react";
import Banner from "../components/allbanner";

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  
const faqs = [
{ question: "What warranty do Isuzu vehicles come with?", answer: "Isuzu vehicles come with a 1-year or 100,000 km warranty (whichever comes first)." },
{ question: "Where can I get my Isuzu vehicle serviced?", answer: "Your Isuzu vehicle can be serviced at any authorized Isuzu 3S dealership nationwide. We ensure professional maintenance using genuine Isuzu parts." },
{ question: "Do you offer financing options?", answer: "Yes, Isuzu Gujranwala Motors partners with several banks and leasing companies to provide flexible financing plans tailored to your business needs." },
{ question: "What are the available Isuzu truck models?", answer: "We offer N-Series light-duty trucks, F-Series medium-duty trucks, and C Series heavy-duty trucks designed for various commercial applications." },
{ question: "What is the fuel efficiency of Isuzu vehicles?", answer: "Isuzu engines are engineered for fuel efficiency and durability, averaging 8–15 km/l depending on the model and load conditions." },
{ question: "Do you provide spare parts for older models?", answer: "Yes, we stock genuine spare parts for both current and discontinued Isuzu models. You can order parts directly through our dealership." },
{ question: "Can I customize my truck or bus?", answer: "Yes, custom configurations and body options are available to meet specific business requirements. Contact our sales department for details." },
{ question: "What is the delivery time for a new vehicle?", answer: "Delivery usually takes 2–6 weeks depending on model availability and customization requirements." },
{ question: "Are Isuzu vehicles suitable for rough terrain?", answer: "Yes, Isuzu trucks are known for their durability and performance on all terrains, ideal for Pakistan’s diverse road conditions." },
{ question: "Can I get fleet management support?", answer: "We offer corporate and fleet management solutions, including scheduled servicing, spare parts packages, and bulk purchase benefits." },
{ question: "What after-sales services do you provide?", answer: "Our after-sales services include periodic maintenance, warranty claims, genuine spare parts, and technical assistance." },
{ question: "How can I contact Isuzu Gujranwala Motors?", answer: "You can reach us via our Contact page, call our helpline, or visit our showroom located at Multan Road, Lahore." },
{ question: "Do you offer roadside assistance?", answer: "Yes, Isuzu provides 24/7 roadside assistance for vehicles under warranty. Contact our service hotline for immediate help." },
{ question: "Can I buy Isuzu genuine parts online?", answer: "We’re working on an online ordering system. Currently, genuine parts are available at all authorized Isuzu 3S dealerships." },
{ question: "Do Isuzu vehicles comply with Euro emission standards?", answer: "Yes, all new Isuzu models comply with international emission standards and are designed for environmental efficiency." },
{ question: "Are there training programs for Isuzu vehicle owners?", answer: "Yes, we occasionally host maintenance and operation workshops for drivers and fleet owners." },
{ question: "What makes Isuzu trucks reliable?", answer: "Isuzu’s diesel engines are globally recognized for efficiency, long lifespan, and low maintenance costs, making them highly reliable." },
{ question: "How do I stay updated about new Isuzu launches?", answer: "Follow our social media channels to get the latest updates on new models and offers." }
];

  const filteredFaqs = faqs.filter((faq) =>
    faq.question.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white">
      {/* Reusable Banner */}
      <Banner
        title="Frequently Asked Questions"
        description="Find quick answers about Isuzu vehicles, services, and dealership support — everything you need to know, in one place."
      />

      {/* FAQ Section */}
      <section className="py-16 px-6 md:px-10 container mx-auto">
        {/* Search Bar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
          viewport={{ once: true }}
          className="max-w-xl mx-auto mb-12 flex items-center gap-3 bg-gray-100 rounded-full px-6 py-3 shadow-sm focus-within:ring-2 focus-within:ring-[#CE2827] transition-all duration-300"
        >
          <Search className="text-[#CE2827]" size={22} />
          <input
            type="text"
            placeholder="Search questions..."
            className="w-full bg-transparent focus:outline-none text-gray-700 placeholder-gray-500"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </motion.div>

        {/* FAQ Items */}
        <div className="max-w-3xl mx-auto space-y-5">
          {filteredFaqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, ease: [0.33, 1, 0.68, 1] }}
              viewport={{ once: true }}
              className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center text-left px-6 py-5 focus:outline-none"
              >
                <span className="font-semibold text-gray-900 text-base md:text-lg">
                  {faq.question}
                </span>
                <motion.svg
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  className="w-5 h-5 text-[#CE2827] flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </motion.svg>
              </button>

              <AnimatePresence initial={false} mode="wait">
                {openIndex === index && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0, y: -5 }}
                    animate={{
                      height: "auto",
                      opacity: 1,
                      y: 0,
                      transition: {
                        height: { duration: 0.5, ease: [0.4, 0, 0.2, 1] },
                        opacity: { duration: 0.35 },
                      },
                    }}
                    exit={{
                      height: 0,
                      opacity: 0,
                      y: -5,
                      transition: {
                        height: { duration: 0.45, ease: [0.4, 0, 0.2, 1] },
                        opacity: { duration: 0.3 },
                      },
                    }}
                    className="px-6 pb-5 bg-gray-50 border-t border-gray-100"
                  >
                    <motion.p
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.1 }}
                      className="text-gray-700 leading-relaxed"
                    >
                      {faq.answer}
                    </motion.p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}

          {filteredFaqs.length === 0 && (
            <p className="text-center text-gray-500 mt-10">
              No results found.
            </p>
          )}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mt-20 bg-gradient-to-r from-[#CE2827]/20 to-[#CE2827]/10 rounded-2xl text-center p-10 shadow-sm"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Still have questions?
          </h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Can’t find what you’re looking for? Our experts are always ready to help.
          </p>
          <a
            href="/contact"
            className="inline-block bg-[#CE2827] text-white px-10 py-3 rounded-full font-semibold shadow-md hover:bg-[#b82020] transition-all duration-300 hover:scale-[1.02]"
          >
            Contact Us
          </a>
        </motion.div>
      </section>
    </div>
  );
};

export default FAQPage;
